<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Designación"
          directory="equipo evaluador"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
            v-if="show"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12" v-if="showTab">
        <app-tab :tabs="tabsHorizontalLab" type="horizontal" />
      </div>
      <div class="col-md-12" v-if="!showTab">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>


<script>
import * as actions from "../../../apiUrl";
import { axiosPatch } from "@/app/helpers/AxiosHelper";
import { axiosGet } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  props: {
    evalTestId: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      showTab: false,
      tabsHorizontalLab: [
        // {
        //   icon: "briefcase",
        //   name: "Anexos",
        //   component: "signature-document-team",
        //   permission: "",
        // },
        {
          icon: "briefcase",
          name: "Equipo Evaluador",
          component: "evaluation-team-400",
          permission: "",
        },
        // {
        //   icon: "file",
        //   name: "Plan de muestreo",
        //   component: "signature-annexes-team",
        //   permission: "",
        // },
      ],
      tabsHorizontal: [
        // {
        //   icon: "briefcase",
        //   name: "Anexos",
        //   component: "signature-document-team",
        //   permission: "",
        // },
        {
          icon: "briefcase",
          name: "Equipo Evaluador",
          component: "evaluation-team-400",
          permission: "",
        },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
    show() {
      let result = true;
      // if (this.evalTest.evaluation_team) {
      //   this.evalTest.evaluation_team.forEach((e) => {
      //     if (e.is_confirmed != 1) result = false;
      //   });
      // }
      return result;
    },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = `/accreditationtechnical/signatureDocument`;
    },
    data() {
      this.$store.dispatch("getEvalTest");

      let url = `evaluator/documentaryEvaluation/show/${this.evalTestId}`;
      this.deleteLoader = true;
      axiosGet(url).then((response) => {
        if (
          response.data.accreditation_applications.accreditation_area.name ==
          "LABORATORIOS"
        ) {
          this.showTab = true;
        }
      });
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      var area = this.evalTest.accreditation_applications.accreditation_area.name;

      if (this.validateEvaluationTeam()) {
        this.$toastr.e(
          "Para continuar el proceso todos los miembros del equipo deben haber aceptado la designación"
        );
        return;
      }
      // if (area == "INSPECCIÓN" && this.evalTest.type == 'E'|| area == "CERTIFICACIÓN" && this.evalTest.type == 'E') {
      //   if(!this.evalTest.standard_evaluate){
      //     this.$toastr.e(
      //       "Ingrese el archivo 'Borrador del plan de evaluación'"
      //     );
      //     return;
      //   }
      // }
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/signatureDocument/signatureDocumentReport/process?evalTestId=${this.evalTestId}`;
      this.deleteLoader = true;
      axiosPatch(url)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
    validateEvaluationTeam() {
      const tmp = this.evalTest.evaluation_team.filter(
        (item) => item.is_confirmed == 1
      );
      return this.evalTest.evaluation_team.length != tmp.length;
    },
  },
};
</script>
